/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import DivisionSelector from '../../common/inputs/DivisionSelector';

const { Option } = Select;

const labelStyle = {
  display: 'block',
  marginBottom: 4,
  fontFamily: 'raleway-medium',
};

const CONTROL_WIDTH = 250;

export default function MaterialSheetSelector({
  workbook: {
    SheetNames = [],
  } = {},
  onSheetChanged,
  divisionIds,
  divisionFilter,
  onDivisionsChanged,
}) {
  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <span style={labelStyle}>Divisions</span>
        <DivisionSelector
          style={{ width: CONTROL_WIDTH, display: 'block' }}
          mode="multiple"
          divisions={divisionIds}
          filter={divisionFilter}
          onChange={onDivisionsChanged}
        />
      </div>
      <div>
        <span style={labelStyle}>Sheet</span>
        <Select
          style={{ width: CONTROL_WIDTH }}
          defaultValue={SheetNames[0]}
          onSelect={onSheetChanged}
        >
          {SheetNames.map((sheet) => <Option value={sheet} key={sheet}>{sheet}</Option>)}
        </Select>
      </div>
    </>
  );
}

MaterialSheetSelector.propTypes = {
  workbook: PropTypes.shape({
    SheetNames: PropTypes.arrayOf(PropTypes.string),
  }),
  onSheetChanged: PropTypes.func.isRequired,
  divisionIds: PropTypes.arrayOf(PropTypes.string),
  divisionFilter: PropTypes.instanceOf(Set),
  onDivisionsChanged: PropTypes.func.isRequired,
};

MaterialSheetSelector.defaultProps = {
  workbook: {},
  divisionIds: [],
  divisionFilter: undefined,
};
